import { AbilityBuilder, Ability } from '@casl/ability';
export var AppAbility = Ability;
export function updateAbility(ability, role) {
  var _AbilityBuilder = new AbilityBuilder(),
      can = _AbilityBuilder.can,
      rules = _AbilityBuilder.rules;

  if (role === 1) {
    can(['delete'], 'IModuleType');
  } else {}

  ability.update(rules);
}